/* istanbul ignore file */
import VerticalAddressInputLayout from '../../ui/layout/form/input/VerticalAddressInputLayout';

interface VerticalCopyableInputProps {
  input: any;
}

const VerticalCopyableInput = ({ ...props }: VerticalCopyableInputProps) => {
  const { input } = props;
  return <VerticalAddressInputLayout>{input}</VerticalAddressInputLayout>;
};

export default VerticalCopyableInput;
